var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackButton = function SvgBackButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3332 23.3333C11.1626 23.3333 10.9922 23.2683 10.8619 23.138L0.19525 12.4713C-0.0650833 12.211 -0.0650833 11.789 0.19525 11.5287L10.8619 0.861998C11.1222 0.601665 11.5442 0.601665 11.8046 0.861998C12.0649 1.12233 12.0649 1.54433 11.8046 1.80466L1.60958 12L11.8046 22.1953C12.0649 22.4557 12.0649 22.8777 11.8046 23.138C11.6742 23.2683 11.5039 23.3333 11.3332 23.3333Z",
    fill: "#555555"
  })));
};
export default SvgBackButton;